import locale from "localization";

export const purchaseOrderRecipient = ["Station"];

export const productTypeOption = [{ label: locale.fuel, value: "fuel" }];
